import { render, staticRenderFns } from "./AppNavList.vue?vue&type=template&id=60955444&scoped=true"
import script from "./AppNavList.vue?vue&type=script&lang=js"
export * from "./AppNavList.vue?vue&type=script&lang=js"
import style0 from "./AppNavList.vue?vue&type=style&index=0&id=60955444&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60955444",
  null
  
)

export default component.exports